<template>
  <v-card>
    <v-expansion-panel v-model="panel" popout>
      <v-expansion-panel-content
        v-for="(listPage, i) in listPages"
        :key="i"
        lazy
      >
        <template v-slot:header>
          <div class="title" v-text="listPage.pageName" />
        </template>
        <v-card>
          <v-form v-model="listFormValid" lazy-validation :ref="'listForm' + i">
            <v-card-text>
              <v-container fluid grid-list-xl>
                <v-layout wrap>
                  <v-flex xs12 sm5>
                    <v-text-field
                      label="Page name"
                      v-model="listPage.pageName"
                      :rules="[formRules.required]"
                    />
                  </v-flex>
                  <v-flex xs12 sm7>
                    <v-text-field
                      label="Title"
                      v-model="listPage.title"
                      :rules="[formRules.required]"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Side menu</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <ActionLink
                          v-model="listPage.sideMenuLink"
                          restrict="SIDE_MENU"
                          @clearLink="$delete(listPage, 'sideMenuLink')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Top menu</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <ActionLink
                          v-model="listPage.topMenuLink"
                          restrict="TOP_MENU"
                          @clearLink="$delete(listPage, 'topMenuLink')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Bottom menu</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <ActionLink
                          v-model="listPage.bottomMenuLink"
                          restrict="BOTTOM_MENU"
                          @clearLink="$delete(listPage, 'bottomMenuLink')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Floating button</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7 v-if="listPage.floatingButton">
                        <v-select
                          v-model="listPage.floatingButton.floatingType"
                          :items="floatingTypes"
                          label="Floating type"
                          :rules="[formRules.required]"
                        />

                        <v-card class="mb-2">
                          <v-card-text>
                            <v-text-field
                              label="Text"
                              v-model="listPage.floatingButton.actionItem.text"
                            />
                            <icon-picker
                              v-model="listPage.floatingButton.actionItem.icon"
                            />
                            <v-layout row wrap>
                              <v-flex xs12 sm4>
                                <ActionType
                                  v-model="
                                    listPage.floatingButton.actionItem.action
                                      .type
                                  "
                                />
                              </v-flex>
                              <v-flex xs12 sm6>
                                <ActionLink
                                  v-model="
                                    listPage.floatingButton.actionItem.action
                                      .link
                                  "
                                  :type="
                                    listPage.floatingButton.actionItem.action
                                      .type
                                  "
                                  @clearLink="
                                    $delete(
                                      listPage.floatingButton.actionItem.action,
                                      'link'
                                    )
                                  "
                                />
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Tap action</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm2>
                        <ActionType v-model="listPage.tapAction.type" />
                      </v-flex>
                      <v-flex xs12 sm5>
                        <ActionLink
                          v-model="listPage.tapAction.link"
                          :type="listPage.tapAction.type"
                          @clearLink="$delete(listPage.tapAction, 'link')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Slide left action items</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-layout
                          wrap
                          v-for="(slideLeftAction,
                          i) of listPage.slideLeftActionItems"
                          :key="i"
                        >
                          <v-flex xs12 sm4>
                            <v-text-field
                              label="Text"
                              v-model="slideLeftAction.text"
                            />
                          </v-flex>
                          <v-flex xs12 sm8>
                            <icon-picker v-model="slideLeftAction.icon" />
                          </v-flex>
                          <v-flex xs12 sm3>
                            <ActionType v-model="slideLeftAction.action.type" />
                          </v-flex>
                          <v-flex xs12 sm8>
                            <ActionLink
                              v-model="slideLeftAction.action.link"
                              :type="slideLeftAction.action.type"
                              @clearLink="
                                $delete(slideLeftAction.action, 'link')
                              "
                            />
                          </v-flex>
                          <v-flex xs12 sm1>
                            <v-btn
                              @click="
                                listPage.slideLeftActionItems.splice(i, 1)
                              "
                              icon
                            >
                              <v-icon v-text="fa('trash-alt')"></v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-btn
                          block
                          @click="
                            listPage.slideLeftActionItems.push({
                              icon: 'thumbsUp',
                              text: '',
                              action: {
                                type: 'NONE'
                              }
                            })
                          "
                        >
                          <v-icon v-text="fa('plus')"></v-icon> add
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Slide right action items</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <v-layout
                          wrap
                          v-for="(slideRightAction,
                          i) of listPage.slideRightActionItems"
                          :key="i"
                        >
                          <v-flex xs12 sm4>
                            <v-text-field
                              label="Text"
                              v-model="slideRightAction.text"
                            />
                          </v-flex>
                          <v-flex xs12 sm8>
                            <icon-picker v-model="slideRightAction.icon" />
                          </v-flex>
                          <v-flex xs12 sm3>
                            <ActionType
                              v-model="slideRightAction.action.type"
                            />
                          </v-flex>
                          <v-flex xs12 sm8>
                            <ActionLink
                              v-model="slideRightAction.action.link"
                              :type="slideRightAction.action.type"
                              @clearLink="
                                $delete(slideRightAction.action, 'link')
                              "
                            />
                          </v-flex>
                          <v-flex xs12 sm1>
                            <v-btn
                              @click="
                                listPage.slideRightActionItems.splice(i, 1)
                              "
                              icon
                            >
                              <v-icon v-text="fa('trash-alt')"></v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-btn
                          block
                          @click="
                            listPage.slideRightActionItems.push({
                              icon: 'thumbsUp',
                              text: '',
                              action: {
                                type: 'NONE'
                              }
                            })
                          "
                        >
                          <v-icon v-text="fa('plus')"></v-icon> add
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-checkbox label="Editable" v-model="listPage.editable" />
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-checkbox
                      label="Search bar"
                      v-model="listPage.showSearchBar"
                    />
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-switch
                      v-model="listPage.isAuthenticationRequired"
                      label="Is authentication required"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm5
                    v-if="appMap && appMap.items['listPages/' + listPage.id]"
                  >
                    <p>Caching strategy</p>
                    <CachingStrategy
                      v-model="
                        appMap.items['listPages/' + listPage.id].cachingStrategy
                      "
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-list two-line>
                      <template
                        v-for="(listPageItem, j) of orderedListPageItems(i)"
                      >
                        <v-divider
                          v-if="j % 2"
                          :key="`${j}-d`"
                          inset
                        ></v-divider>
                        <v-list-tile
                          :key="j"
                          avatar
                          @click.stop="
                            $router.push({
                              name: 'list-page-item',
                              params: {
                                listPage: listPage.id,
                                id: listPageItem.id
                              }
                            })
                          "
                          :disabled="loading"
                        >
                          <v-list-tile-avatar>
                            <img
                              v-if="listPageItem.image"
                              :src="listPageItem.image"
                              aspect-ratio="2.75"
                            />
                          </v-list-tile-avatar>

                          <v-list-tile-content>
                            <v-list-tile-title v-text="listPageItem.title" />
                            <v-list-tile-sub-title
                              v-text="listPageItem.subTitle"
                            />
                          </v-list-tile-content>

                          <v-list-tile-action :class="$style.listAction">
                            <v-btn
                              icon
                              @click.stop="
                                reorderListPageItem(
                                  listPage,
                                  listPagesItems[i],
                                  listPageItem,
                                  true
                                )
                              "
                              :disabled="loading"
                              v-if="j > 0"
                            >
                              <v-icon v-text="fa('angle-up')"></v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              @click.stop="
                                reorderListPageItem(
                                  listPage,
                                  listPagesItems[i],
                                  listPageItem,
                                  false
                                )
                              "
                              :disabled="loading"
                              v-if="j < listPagesItems[i].length - 1"
                            >
                              <v-icon v-text="fa('angle-down')"></v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              @click.stop="
                                removeListPageItem(listPage, listPageItem)
                              "
                              :disabled="loading"
                            >
                              <v-icon v-text="fa('trash-alt')"></v-icon>
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                      </template>
                      <v-list-tile
                        @click="addListPageItem(listPage)"
                        :disabled="loading"
                      >
                        <v-list-tile-action>
                          <v-icon v-text="fa('plus')"></v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            Add a list page item
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="warning"
                flat
                @click="remove(listPage)"
                :disabled="loading"
                >Remove</v-btn
              >
              <v-spacer />
              <v-btn
                color="primary"
                @click="save(listPage, i)"
                :disabled="loading"
                >Save</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card-actions>
      <v-layout row align-center justify-center wrap>
        <v-flex xs3>
          <v-text-field label="Name" v-model="newListPageName" />
        </v-flex>
        <v-flex xs3>
          <v-btn
            @click="addListPage"
            color="primary"
            :disabled="loading || !newListPageName"
          >
            <v-icon v-text="fa('list')"></v-icon>
            Add a list page
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import ActionLink from "../../components/ActionLink";
import ActionType from "../../components/ActionType";
import { db } from "../../plugins/firebase";
import { appMapSuffix, eventHub, FloatingType } from "../../config/constants";
import CachingStrategy from "../../components/CachingStrategy";
const listPagesCollection = db.collection("listPages");

export default {
  name: "ListPagesList",
  components: {
    ActionLink,
    CachingStrategy,
    ActionType
  },
  data: () => ({
    listFormValid: true,
    newListPageName: null,
    loading: false,
    listPages: [],
    listPagesItems: [],
    panel: null,
    appMap: null
  }),
  watch: {
    "$route.params.language": {
      immediate: true,
      async handler(language) {
        this.$bind(
          "listPages",
          listPagesCollection.where("language", "==", String(language))
        );
        this.$bind(
          "appMap",
          db.collection("appMaps").doc(language + appMapSuffix)
        );
      }
    },
    async listPages(listPages) {
      if (listPages.length) {
        this.listPagesItems = await Promise.all(
          listPages.map(listPage =>
            listPagesCollection
              .doc(listPage.id)
              .collection("items")
              .get()
              .then(results =>
                results.docs.map(doc => ({
                  id: doc.id,
                  ...doc.data()
                }))
              )
          )
        );
        if (this.$route.params.listPage) {
          this.panel = listPages.findIndex(
            listPage => this.$route.params.listPage === listPage.id
          );
        }
      }
    },
    panel(value) {
      if (
        !this.$route.params.listPage ||
        (this.listPages[value]
          ? this.$route.params.listPage !== this.listPages[value].id
          : true)
      ) {
        this.$router.replace({
          params: {
            listPage: this.listPages[value] ? this.listPages[value].id : null
          }
        });
      }
    }
  },
  methods: {
    async addListPage() {
      this.panel = null;
      this.loading = true;
      try {
        await db.runTransaction(async t => {
          const newListPage = listPagesCollection.doc();
          t.set(newListPage, {
            editable: true,
            language: this.$route.params.language,
            pageName: this.newListPageName,
            showSearchBar: true,
            slideLeftActionItems: [],
            slideRightActionItems: [],
            tapAction: {
              type: "NONE"
            },
            floatingButton: {
              actionItem: {
                icon: null,
                text: null,
                action: {
                  type: "NONE"
                },
                showCondition: null,
                preferredViewType: null
              },
              floatingType: "CENTER_DOCKED"
            },
            title: null,
            isAuthenticationRequired: false,
            type: "LIST_PAGE"
          }).set(
            this.$firestoreRefs.appMap,
            {
              items: {
                ["listPages/" + newListPage.id]: {
                  cachingStrategy: "ON_OPEN",
                  isAuthenticationRequired: false,
                  name: this.newListPageName,
                  type: "LIST_PAGE",
                  version: 1
                }
              }
            },
            {
              merge: true
            }
          );
        });
        eventHub.$emit("message", "green");
        this.newListPageName = null;
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async save(listPage, i) {
      if (!this.$refs["listForm" + i][0].validate()) {
        return;
      }
      this.loading = true;
      try {
        await db.runTransaction(async t => {
          t.set(listPagesCollection.doc(listPage.id), listPage);
          t.set(this.$firestoreRefs.appMap, this.appMap);
        });
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async remove(listPage) {
      this.loading = true;
      const appMapItem = this.appMap.items["listPages/" + listPage.id];
      try {
        await db.runTransaction(async t => {
          t.delete(listPagesCollection.doc(listPage.id));
          delete this.appMap.items["listPages/" + listPage.id];
          t.update(this.$firestoreRefs.appMap, this.appMap);
        });
        eventHub.$emit("message", "green");
      } catch (error) {
        this.appMap.items["listPages/" + listPage.id] = appMapItem;
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async addListPageItem(listPage) {
      this.loading = true;
      try {
        const listPageItem = await listPagesCollection
          .doc(listPage.id)
          .collection("items")
          .add({
            title: null,
            subTitle: null,
            order:
              this.listPagesItems[this.listPages.indexOf(listPage)].length + 1,
            image: null,
            data: {}
          });
        eventHub.$emit("message", "green");
        this.$router.push({
          name: "list-page-item",
          params: { listPage: listPage.id, id: listPageItem.id }
        });
      } catch (error) {
        eventHub.$emit("message", "red", error.message);
      }
      this.loading = false;
    },
    async reorderListPageItem(listPage, listPageItems, item, up) {
      this.loading = true;
      const listPageItemsOrder = listPageItems
        .filter(
          listPageItem =>
            listPageItem === item ||
            listPageItem.order === item.order + (up ? -1 : 1)
        )
        .map(listPageItem => {
          let order;
          if (item === listPageItem) {
            order = listPageItem.order + (up ? -1 : 1);
          } else {
            order = listPageItem.order + (up ? 1 : -1);
          }
          return [listPageItem, order];
        });
      try {
        await db.runTransaction(async t =>
          listPageItemsOrder.forEach(([listPageItem, order]) =>
            t.update(
              listPagesCollection
                .doc(listPage.id)
                .collection("items")
                .doc(listPageItem.id),
              "order",
              order
            )
          )
        );
        listPageItemsOrder.forEach(([listPageItem, order]) => {
          listPageItem.order = order;
        });
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async removeListPageItem(listPage, listPageItem) {
      this.loading = true;
      try {
        await db.runTransaction(async t =>
          t.delete(
            listPagesCollection
              .doc(listPage.id)
              .collection("items")
              .doc(listPageItem.id)
          )
        );
        const listPageItems = this.listPagesItems[
          this.listPages.indexOf(listPage)
        ];
        listPageItems.splice(listPageItems.indexOf(listPageItem), 1);
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.message);
      }
      this.loading = false;
    }
  },
  computed: {
    orderedListPageItems() {
      return index =>
        this.listPagesItems.length && this.listPagesItems[index]
          ? [...this.listPagesItems[index]].sort((a, b) => a.order - b.order)
          : [];
    },
    floatingTypes: () => FloatingType
  }
};
</script>

<style lang="sass" module>
.listAction
  flex-direction: row
</style>
